// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/browser/global/" + chunkId + "." + {"111":"44124c6d137af6ad68fb","341":"463b6804b0e86838f78c","884":"4cb06e795eb4d2c5ab5a"}[chunkId] + ".js";
};